import { client } from '../client';

export interface ClientCustomerIoRouting {
  enabled: boolean;
  exclusive: boolean;
  browser_write_key: string | null;
}

export const getClientCustomerIo = async (code: string): Promise<ClientCustomerIoRouting> => {
  const { data } = await client.get(`/clients/${encodeURIComponent(code)}/customer-io`);
  return data;
};
